import { all, call, fork, put, select, take, takeLatest } from 'redux-saga/effects'

import { newSearch, nextPage } from '@/results/store/actions'
import {
  getResultsList,
  getResultsSearchParams
} from '@/results/store/selectors'

import { SWITCHES } from '../../config'
import { JOB_SEARCH } from '../../page/constants'
import { getPageType } from '../../page/store/selectors'
import * as tracking from '../../tracking'
import { JOB } from '../constants'

import * as actions from './actions'
import {
  getSearchType,
  getSelectedId,
  getShowFirstResult
} from './selectors'

/**
 * @private exposed only for tests
 */
export function * watchNav () {
  while (true) {
    const { payload: { offset } } = yield take([actions.selectPrevResultItem, actions.selectNextResultItem])
    const { items, selectedId, params: { type } } = yield all({
      items: select(getResultsList),
      selectedId: select(getSelectedId),
      params: select(getResultsSearchParams)
    })

    const index = items.findIndex(({ id }) => id === selectedId)
    if (index < 0) continue
    const newIndex = index + offset
    if (newIndex < 0) continue
    if (newIndex + 1 >= items.length) {
      yield put(nextPage.trigger())
    }
    if (newIndex >= items.length) {
      continue
    }
    const { id: newId } = items[newIndex]
    yield put(actions[type].setSelectedId(newId))
    yield call(trackNav)
  }
}

/**
 * @private exposed only for tests
 */
export function * trackNav () {
  const type = yield select(getSearchType)
  yield call(tracking.trackNavigateNext, { type })
}

/**
 * @private exposed only for tests
 */
export function * selectFirstResult (
  {
    payload: [firstItem],
    meta: {
      searchParams: {
        type: searchType
      }
    }
  }
) {
  // enable feature only for desktop layout
  if (!SWITCHES.showFirstResultMode || window.innerWidth < 1200) {
    return
  }
  const { showFirstResult, selectedId, pageType } = yield all({
    showFirstResult: select(getShowFirstResult),
    selectedId: select(getSelectedId),
    pageType: select(getPageType)
  })

  if (firstItem && (showFirstResult || (pageType === JOB_SEARCH || searchType === JOB)) && !selectedId) {
    const { id } = firstItem
    yield put(actions[searchType].setSelectedId(id, { autoSelect: true }))
  }
}

export default all([
  fork(watchNav),
  takeLatest(
    newSearch.success,
    selectFirstResult
  )
])
